import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';

import { useSearchParams } from '@/lib/compat/navigation';
import {
  EmailChangeConfirmContent,
  EmailChangeRefused,
} from '@/screens/email-change/EmailChangeConfirmContent';

export const Route = createFileRoute('/_app/email-change/confirm/')({
  component: EmailChangeConfirmRoute,
});

function EmailChangeConfirmRoute() {
  const sp = useSearchParams();
  const t = useTranslations('auth.emailChange');
  const token = sp.get('token') ?? undefined;

  if (!token) {
    return <EmailChangeRefused title={t('invalidTitle')} message={t('invalidDescription')} />;
  }

  return <EmailChangeConfirmContent token={token} />;
}
